import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { FC } from 'react';
import { useParams } from 'react-router';
import { LocationsLastRefresh } from 'src/locations/LocationsLastRefresh';
import { LocationsRefresh } from 'src/locations/LocationsRefresh';
import { RSimLocationDetailsFleetButton } from 'src/locations/RSimLocationDetailsFleetButton';
import { RSimLocationDetailsMap } from 'src/locations/RSimLocationDetailsMap';
import { SimLocationDetailsMap } from 'src/locations/SimLocationDetailsMap';
import { SimLocationDetailsFleetButton } from 'src/locations/SimLocationDetailsFleetButton';
import { RSimLocationDetailsInfo } from 'src/rSimInventory/Location/RSimLocationDetailsInfo';
import { SimLocationDetailsInfo } from 'src/simInventory/Location/SimLocationDetailsInfo';

export const ProductLocationDetails: FC = () => {
  const { iccid, euicc } = useParams();

  if (iccid === undefined && euicc === undefined) {
    throw new Error('No ICCID/EUICC in route');
  }

  return (
    <Box data-testid="locationDetails" px={32} py={16} display="flex" flexDirection="column">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="end"
        gap={12}
        mb={12}
        flexGrow="0"
        flexShrink="0"
      >
        <LocationsLastRefresh
          dataTestId="locationsDetails.lastRefreshed"
          type="active"
          predicate={(query) => {
            const hasMeta = query.meta !== undefined;
            const isLocationsQuery = hasMeta && query.meta.isLocationsDetails === true;

            return isLocationsQuery;
          }}
        />
        <LocationsRefresh
          data-testid="locationsDetails.refresh"
          type="active"
          predicate={(query) => {
            const hasMeta = query.meta !== undefined;
            const isLocationsQuery = hasMeta && query.meta.isLocationsDetails === true;

            return isLocationsQuery;
          }}
        />
      </Box>
      <Box sx={{ overflowY: 'hidden' }} flexGrow="1" flexShrink="1">
        <Grid
          container
          columns={{ xs: 1, md: 2 }}
          spacing={12}
          sx={{ overflowY: 'auto' }}
          height="100%"
        >
          <Grid
            data-testid="locationDetails.fields"
            size={1}
            height="100%"
            sx={{ overflowY: 'auto' }}
          >
            {iccid ? <SimLocationDetailsInfo iccid={iccid} /> : null}
            {euicc ? <RSimLocationDetailsInfo euicc={euicc} /> : null}
          </Grid>
          <Grid data-testid="locationDetails.map" size={1} height="100%">
            <Stack direction="column" height="100%">
              {iccid ? <SimLocationDetailsMap iccid={iccid} /> : null}
              {euicc ? <RSimLocationDetailsMap euicc={euicc} /> : null}
              <Box flexGrow="0" flexShrink="0">
                {iccid ? <SimLocationDetailsFleetButton iccid={iccid} /> : null}
                {euicc ? <RSimLocationDetailsFleetButton euicc={euicc} /> : null}
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
